module.exports = __webpack_public_path__ + "img/double_bubble_layout_2.df4d5773.png";